import { set } from "lodash";

export class MenuSidebar extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // Initialize the sidebar functionality
        this.init();
    }

    init() {
        this.checkSidebarState();
        this.initEventHandlers();
    }

    checkSidebarState() {
        // Check session storage for sidebar state
        const sidebarState = sessionStorage.getItem('sidebarState');
        if (sidebarState === 'collapsed') {
            const sidebar = document.querySelector('.main-sidebar');
            if (sidebar) {
                // modify transition to avoid flicker
                sidebar.style.transition = 'none';
                sidebar.classList.add('sidebar-collapsed');
            }
            const toggler = document.querySelector('.sidebar-toggler');
            if (toggler) {
                // modify transition to avoid flicker
                toggler.style.transition = 'none';
                toggler.classList.add('sidebar-collapsed');
            }

            setTimeout(() => {
                // Restore transition after applying the class
                if (sidebar) {
                    sidebar.style.transition = '';
                }
                if (toggler) {
                    toggler.style.transition = '';
                }
            }, 500); // Delay to allow styles to apply

        }
    }

    initEventHandlers()
    {
        this.toggleSidebar = this.toggleSidebar.bind(this);

        const toggleButton = document.querySelector('.sidebar-toggler');
        if (toggleButton) {
            toggleButton.addEventListener('click', this.toggleSidebar);
        }

        // Add event listener for sidebar links when collapsed
        const menulinks = this.closest('.main-sidebar').querySelectorAll('li a[alt]'); 
        menulinks.forEach(link => {
            link.addEventListener("mouseover", this.toggleMenuTitle.bind(this));
            link.addEventListener("mouseleave", () => {
                const titleElement = document.querySelector('.sidebar-menu-title');
                if (titleElement) {
                    titleElement.remove();
                }
            });
        });

    }



    toggleMenuTitle(event)
    {
        if (this.closest('.main-sidebar').classList.contains('sidebar-collapsed')) {
            const existingTitle = document.querySelector('.sidebar-menu-title');
            if (existingTitle) {
                return; // If title already exists, do nothing
            }
            const title = event.currentTarget.getAttribute('alt');
            const titleElement = document.createElement('span');
            titleElement.className = 'sidebar-menu-title';
            titleElement.textContent = title;
            titleElement.style.left = `${event.currentTarget.getBoundingClientRect().left+50}px`;
            titleElement.style.top = `${event.currentTarget.getBoundingClientRect().top}px`;
            document.body.appendChild(titleElement);
        }
    }


    toggleSidebar() {
        const sidebar = this.closest('.main-sidebar');
        const toggler = document.querySelector('.sidebar-toggler');
        if (sidebar) {
            sidebar.classList.toggle('sidebar-collapsed');
            toggler.classList.toggle('sidebar-collapsed');
        }

        // if toggled, set the session storage
        if (sidebar.classList.contains('sidebar-collapsed')) {
            sessionStorage.setItem('sidebarState', 'collapsed');
        } else {
            sessionStorage.removeItem('sidebarState');
        }

        setTimeout(() => {
            $("body").Vetology("setDoubleScroll");
        }, 1000); // Delay to allow styles to apply
    }
}

// Define the custom element
customElements.define('menu-sidebar', MenuSidebar);